import Relay from 'react-relay';
import PropTypes from 'prop-types';
import {injectIntl, FormattedMessage, defineMessages} from 'react-intl';
import React from 'react';
import queryString from 'query-string';
import {Alert} from 'react-bootstrap';
import {ChannelOptionEdit} from '../genericChannelOptionEdit.react';
import ScenarioBoxAsWizard from '../../scenarios/ScenarioBoxAsWizard.react';
import ScenarioIcon from '../../scenarios/ScenarioIcon.react';
import AcceptLinkInvitationMutation from '../AcceptLinkInvitationMutation';
import {wrapNotFound} from '../../app/NotFoundHandler.react';
import AppPanel from '../../fw/AppPanel.react';
import ChannelIcon from '../../channel-defs/ChannelIcon.react';
import types from '../../../common/model-api/types';
import Formsy from 'formsy-react';
import LoadingButtonNew from '../../fw/LoadingButtonNew.react';
import Input from '../../fw/Input.react';
import CheckLinkInvitationMutation from '../CheckLinkInvitationMutation';
import {sendError} from '../../app/errorDisplayer';
import AgentLink from '../../fw/AgentLink.react';
import UpdateChannelConfigMutation from '../UpdateChannelConfigMutation.react';
import TestChannelAuthMutation from '../TestChannelAuthMutation.react';
import UpdateChannelAuthMutation from '../UpdateChannelAuthMutation.react';
import {getLastOrganisationId} from '../../app/LastOrganisationId';

import '../../fw/FormFields.scss';
import './pohodaChannelEdit.scss';

const messages = defineMessages({
	checkingError: {id: 'channelOptionEdit.checkingError', 'defaultMessage': 'Error during checking invitation'},
	oneTimePassword: {id: 'AgentChannelEdit.label', 'defaultMessage': 'One-time password'},
	oneTimePasswordHelp: {id: 'AgentChannelEdit.help', 'defaultMessage': 'Copy one-time password from the installed Dativery Agent for the database to connect.'},
	saving: {id: 'common.saving', 'defaultMessage': 'Saving…'},
	save: {id: 'common.saved', 'defaultMessage': 'Save'},
	title: {id: 'channelOptionEdit.title', 'defaultMessage': 'Editing application option'},
});

class AgentChannelEdit extends ChannelOptionEdit {
	static propTypes = {
		cancel: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]),
		connect: PropTypes.bool,
		createCallback: PropTypes.func,
		intl: PropTypes.object.isRequired,
		user: PropTypes.object.isRequired,
		wrapper: PropTypes.bool
	};

	constructor(props) {
		super(props);

		this.state = {
			...this.state,
			loading: false,
			canSubmit: false,
			invitationError: false,
			showOneTimePassword: Boolean(this.props.connect),
			extraArgs: '{}'
		};
	}

	checkLinkInvitationEnd(checkLinkInvitation) {
		let error = '';

		if (!checkLinkInvitation.success) {
			error = checkLinkInvitation.error;
		}

		this.setState({
			loading: false,
			invitationError: error,
			showOneTimePassword: Boolean(!checkLinkInvitation.success),
			extraArgs: checkLinkInvitation.extraArgs || '{}'
		});

		if (!error) {
			return new Promise((resolve, reject) => {
				Relay.Store.commitUpdate(
					new AcceptLinkInvitationMutation({
						'channel': this.props.user.organisation.channel,
						'invitationId': this.state.invitationId,
					}), {onSuccess: () => {
						resolve();
					}, onFailure: (err) => {
						reject(err);
					}}
				);
			});
		}
	}

	getColumns() {
		let columns = super.getColumns();
		let extraArgs = {};

		try {
			extraArgs = JSON.parse(this.state.extraArgs);
		}
		catch (e) {}

		Object.keys(columns).forEach((key) => {
			if (key === 'agentInvitationId') {
				this.originalOptions[key] = this.state.invitationId;
			}
			else if (key.startsWith('cz-pohoda-') || key.startsWith('en-pohoda-')) {
				let realKey = key.substring('cz-pohoda-'.length);

				if (realKey in extraArgs || !(key in this.originalOptions)) {
					this.originalOptions[key] = extraArgs[realKey];
				}
			}
		});

		return columns;
	}

	getError() {
		let error = null;
		if (this.state.invitationError) {
			error = (
				<Alert bsStyle="danger">
					<h4><FormattedMessage defaultMessage="Error: {message}" id="pohodaChannelEdit.errorHeader" values={{message: this.state.invitationError}} /></h4>
					<p>
						<FormattedMessage defaultMessage="Go to Dativery agent and copy one-time password for this database in {channelDefName} once more." id="pohodaChannelEdit.error.onceMore" values={{channelDefName: this.props.user.organisation.channel.channelDef.name}} />
					</p>
				</Alert>
			);
		}

		return error;
	}

	onSubmit = (data) => {
		this.setState({
			loading: true,
			invitationId: data.invitationId
		});

		Relay.Store.commitUpdate(
			new CheckLinkInvitationMutation({
				'invitationId': data.invitationId,
			}), {onSuccess: ({checkLinkInvitation}) => {
				this.checkLinkInvitationEnd(checkLinkInvitation);
			}, onFailure: (e) => {
				this.checkLinkInvitationEnd({
					error: this.props.intl.formatMessage(messages.checkingError)
				});
				sendError(e);
			}}
		);
	}

	enableButton = () => {
		this.setState({
			canSubmit: true
		});
	}

	disableButton = () => {
		this.setState({
			canSubmit: false
		});
    };

	renderOneTimePassword() {
		let params = queryString.parse(window.location.search || '') || {};
		let defaultVale = params.invitationId || '';

		return (<Formsy.Form
			className="BasicEditor"
			onInvalid={this.disableButton}
			onValid={this.enableButton}
			onValidSubmit={this.onSubmit}
		>
			<Alert bsStyle="warning">
				<FormattedMessage defaultMessage="{channelDefName} needs to be connected by {dativeryAgent}. Install it, if not yet done, and copy one-time password for {channelDefName} database from there." id="ScenarioPrerequisite.message3" values={{
					channelDefName: this.props.user.organisation.channel.channelDef.name,
					dativeryAgent: <AgentLink />
				}} />
			</Alert>
			<div>
				<div className="formGroup">
					<div className="fields">
						<Input
							help={this.props.intl.formatMessage(messages.oneTimePasswordHelp)}
							label={this.props.intl.formatMessage(messages.oneTimePassword)}
							maxLength={8000}
							name="invitationId"
							required
							rowClassName="name"
							type="text"
							value={defaultVale}
						/>
					</div>
				</div>
			</div>

			<div className="BasicEditorToolbar">
				<LoadingButtonNew
					className="btn btn-primary submit"
					disabled={!this.state.canSubmit}
					isLoading={this.state.loading}
					progressText={this.props.intl.formatMessage(messages.saving)}
					text={this.props.intl.formatMessage(messages.save)}
					type='submit'
				/>
			</div>
		</Formsy.Form>);
	}

	connectionForm() {
		return (
			<div className="connectForm">
				{this.renderPrototype()}
			</div>
		);
	}

	renderContent() {
		let channelDef = this.props.user.organisation.channel.channelDef;

		return (
			<div className={(this.props.connect ? "pohodaChannelConnect" : "pohodaChannelEdit") + " " + (this.state.hasIc ? "haveIc" : "dontHaveIc")}>
				<h2><div className="channelAdd-logo"><ChannelIcon channelDef={channelDef} size={128}/></div> {channelDef.name}</h2>

				{this.getError()}

				{this.state.showOneTimePassword ? this.renderOneTimePassword() : this.connectionForm()}
			</div>
		);
	}

	render() {
		let {channel} = this.props.user.organisation;

		let content = this.renderContent();

		if (this.props.wrapper) {
			return content;
		}

		return (
			<AppPanel breadcrumbParams={[
				{type: types['channels'], data: channel},
				{type: types['scenarios'], data: this.props.user.scenario},
				{type: types['organisations'], data: this.props.user.organisation}]
			}title={this.props.intl.formatMessage(messages.title)}>
				{content}
			</AppPanel>
		);
	}
}


export default Relay.createContainer(wrapNotFound(injectIntl(AgentChannelEdit), (props) => {
	return props.user.organisation && props.user.organisation.channel;
}), {
	initialVariables: {
		organisationId: '',
		channelId: '',
		scenarioId: '',
		scenarioSelected: false,
		secret: '',
        invitationId: ''
	},
	prepareVariables (variables) {
		if (!variables.organisationId) {
            variables.organisationId = getLastOrganisationId();
        }

		variables['scenarioSelected'] = variables['scenarioId'] ? true : false;

		return variables;
	},
	fragments: {
		user: () => Relay.QL`
			fragment on User {
				scenario(id: $scenarioId) @include(if: $scenarioSelected) {
					id,
					realId,
					${ScenarioBoxAsWizard.getFragment('scenario')},
					${ScenarioIcon.getFragment('scenario')},
					urlFragment
				},
				organisation(id: $organisationId) {
					id,
					realId,
					name,
					users(first: 2) {
						edges {
							node {
								id,
								realId
							}
						}
					},
					${ScenarioBoxAsWizard.getFragment('organisation')},
					channel(id: $channelId) {
						${AcceptLinkInvitationMutation.getFragment('channel')}
						${UpdateChannelConfigMutation.getFragment('channel')}
						${TestChannelAuthMutation.getFragment('channel')}
						${UpdateChannelAuthMutation.getFragment('channel')}
						id,
						realId,
						organisation_id,
						activated,
						channelDef {
							id,
							name,
							type,
							authType,
							metadata,
							connectRequirement,
							requiresAgent,
							canUseAgent,
							icon,
							realId,
							channelOptionDefs(first: 100) {
								edges {
									node {
										id,
										key,
										name,
										type,
										required,
										disabled,
										step,
										datiQuery,
										isAuthInfo,
										isAuthIdentity,
										description,
										examples,
										enumValues,
										datiQuery,
										fileContentTypes,
										defaultValue,
										prefix,
										suffix,
										regexp
									}
								}
							}
						},
						type,
						options,
						currentUserOptions,
						authOptions,
						name,
						enabled
					}
				},
			}
		`,
	},
});
